"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var objectInspect = require("object-inspect");
var StringHelper_1 = require("../util/StringHelper");
var Result_1 = require("./Result");
/**
 * @hidden
 */
var ResultWithData = /** @class */ (function (_super) {
    __extends(ResultWithData, _super);
    function ResultWithData(newData) {
        var actions = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            actions[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, actions) || this;
        _this.hasData = false;
        /**
         * Optional state machine data
         */
        _this._newData = undefined;
        _this.newData = newData;
        return _this;
    }
    Object.defineProperty(ResultWithData.prototype, "newData", {
        /**
         * @hidden
         * @return {TData}
         */
        get: function () {
            if (!this._newData) {
                throw new Error("No data!");
            }
            return this._newData;
        },
        /**
         * @hidden
         * @param value
         */
        set: function (value) {
            this.hasData = true;
            this._newData = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResultWithData.prototype, "dataString", {
        /**
         * @hidden
         * @return {string}
         */
        get: function () {
            return this.hasData ? StringHelper_1.dataToString(this.newData) : "";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     * @return {string}
     */
    ResultWithData.prototype.toString = function () {
        return [this.type,
            objectInspect({
                actions: this.actions,
                data: this.newData,
            })].join(' ');
    };
    return ResultWithData;
}(Result_1.default));
exports.default = ResultWithData;
//# sourceMappingURL=ResultWithData.js.map